var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8487 9.81601V6.84961H34.4455L29.4199 9.81601H37.8487Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6625 9.81601C40.6241 9.01921 40.2929 8.29441 39.7649 7.76161C39.2033 7.20001 38.4209 6.84961 37.5617 6.84961C35.8913 6.84961 34.5377 8.16961 34.4609 9.81601H40.6625Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4457 6.84961V38.2704C34.4457 39.864 33.1497 41.1552 31.5609 41.1552H7.81055V9.96481C7.81055 8.24641 9.20735 6.84961 10.9353 6.84961H34.4457Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 38.4912H4.80078C4.85358 39.1968 5.15118 39.8352 5.62158 40.3104C5.84718 40.5312 6.10638 40.7232 6.39438 40.8528C6.77838 41.0448 7.21038 41.1504 7.66638 41.1504H31.5656C30.044 41.1504 28.82 39.9744 28.7 38.4912Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 29.1748H31.4789V31.042H10.7812V29.1748Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 32.9951H31.4789V34.8623H10.7812V32.9951Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2852 15.341V12.0098H12.0388V15.341H11.2852Z",
    fill: "#F7C680"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1004 15.341L13.4876 13.205V15.341H12.7676V12.0098H13.454L15.0716 14.1506V12.0098H15.7868V15.341H15.1004Z",
    fill: "#F7C680"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4627 15.341L16.1523 12.0098H16.9587L17.8659 14.5202L18.7779 12.0098H19.5555L18.2307 15.341H17.4627Z",
    fill: "#F7C680"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2468 13.675C23.2468 14.635 22.4788 15.3742 21.4564 15.3742C20.4388 15.3742 19.666 14.6398 19.666 13.675C19.666 12.7054 20.4388 11.9854 21.4564 11.9854C22.4788 11.9854 23.2468 12.7102 23.2468 13.675ZM20.4436 13.675C20.4436 14.2606 20.914 14.7166 21.4708 14.7166C22.0276 14.7166 22.4788 14.2606 22.4788 13.675C22.4788 13.0894 22.0276 12.643 21.4708 12.643C20.9092 12.643 20.4436 13.0894 20.4436 13.675Z",
    fill: "#F7C680"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7402 15.341V12.0098H24.4938V15.341H23.7402Z",
    fill: "#F7C680"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0805 12.5374L27.6437 13.0702C27.4133 12.8062 27.0869 12.6382 26.7797 12.6382C26.2085 12.6382 25.7669 13.0798 25.7669 13.6606C25.7669 14.2414 26.2085 14.6878 26.7797 14.6878C27.0773 14.6878 27.4085 14.5342 27.6437 14.299L28.0853 14.779C27.7349 15.139 27.2261 15.3742 26.7413 15.3742C25.7477 15.3742 24.9941 14.635 24.9941 13.6702C24.9941 12.7102 25.7621 11.9854 26.7701 11.9854C27.2453 11.9854 27.7493 12.2014 28.0805 12.5374Z",
    fill: "#F7C680"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2801 12.6329V13.3577H30.888V13.9817H29.2801V14.7209H31.1185V15.3449H28.5312V12.0137H31.0657V12.6377H29.2801V12.6329Z",
    fill: "#F7C680"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2008 27.004C43.2008 31.2184 39.7783 34.6408 35.5639 34.6408H34.4456V29.38H35.5639C36.8743 29.38 37.9448 28.3144 37.9448 27.004C37.9448 25.6936 36.8743 24.628 35.5639 24.628H19.9688V19.3672H35.5639C39.7783 19.3672 43.2008 22.7944 43.2008 27.004Z",
    fill: "#61BE7A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9746 19.3672H20.6274V24.628H19.9746V19.3672Z",
    fill: "#4BA072"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9745 17.0107V26.9851L11.8145 21.9979L19.9745 17.0107Z",
    fill: "#61BE7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutIncome);
export default __webpack_public_path__ + "static/media/checkout_income.59fe40b56e0f67ca9c4a05082b67e89b.svg";
export { ForwardRef as ReactComponent };